import { render } from "./GoodsItem.vue?vue&type=template&id=4ef59a24&scoped=true"
import script from "./GoodsItem.vue?vue&type=script&lang=js"
export * from "./GoodsItem.vue?vue&type=script&lang=js"

import "./GoodsItem.vue?vue&type=style&index=0&id=4ef59a24&scoped=true&lang=scss"

import exportComponent from "F:\\webStorm workspace\\ujk_ad\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ef59a24"]])

export default __exports__